import Schema from 'validate';
import { isEmail, isPostalCode } from 'validator';

// import Schemas
import HochschuleSchema from 'src/lib/paths/hochschule_FULL_Paths.json';
const P = HochschuleSchema.attributes;

const mailValidator = (val: string) => isEmail(val);
const postalCodeValidator = (val: string) => isPostalCode(val, 'DE');

const NeueHochschuleDatenValidator = new Schema({
	[P.Geschaeftsbezogene_Daten_Name_Der_Organisation.path]: {
		type: String,
		required: true,
	},
	[P.Geschaeftsbezogene_Daten_Kuerzel.path]: {
		type: String,
		required: true,
	},
	[P.Geschaeftsbezogene_Daten_Rechtsform_Der_Organisation.path]: {
		type: String,
		required: true,
	},
	[P.Unternehmensprofil_Steuernummer.path]: {
		type: String,
		required: true,
	},
	[P.Unternehmensprofil_U_St_Id_Nr.path]: {
		type: String,
	},
	[P.Adressdaten_Strasse_Und_Hausnummer.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Adresszusatz.path]: {
		type: String,
	},
	[P.Adressdaten_PLZ.path]: {
		type: String,
		required: true,
		use: { postalCodeValidator },
		message: {
			postalCodeValidator: 'Ungültige Postleitzahl.',
		},
	},
	[P.Adressdaten_Ort.path]: {
		type: String,
		required: true,
	},
	[P.Adressdaten_Landkreis_Kreisfreie_Stadt.path]: {
		type: String,
		required: true,
	},
	[P.Kontaktdaten_E_Mail.path]: {
		type: String,
		required: true,
		use: { mailValidator },
		message: {
			mailValidator: 'Ungültige E-Mail-Adresse.',
		},
	},
	[P.Kontaktdaten_Telefon.path]: {
		type: String,
		required: true,
		use: {
			phone: (val: string) => /^[0-9\s]*$/.test(val),
		},
		message: {
			phone: 'Diese Telefonnummer ist ungültig. Es sind nur Zahlen und Leerzeichen erlaubt.',
		},
	},
});

NeueHochschuleDatenValidator.message({
	required: (_path: string) => 'Dies ist ein Pflichtfeld',
	type: (path: string) => `Das Formular ist fehlerhaft, bitte melden Sie diesen Felder. Geben Sie als Grund "falscher Datantyp, ${path}" an`,
});

export default NeueHochschuleDatenValidator;
